<script setup lang="ts">
import { onMounted, ref } from 'vue';

const shouldRender = ref(false)

onMounted(() => {
  if(typeof window !== 'undefined') shouldRender.value = true
})

</script>

<template>
  <div class="contents" >
    <slot v-if="shouldRender" ></slot>
  </div>
</template>